<template>
  <div style="height: 80px; width: 100%;"></div>
  <div class="block text-center">
    <el-carousel :height="carouselHeight">
      <el-carousel-item v-for="(item, index) in imageUrls" :key="index">
        <a :href="item.link">
          <img :src="item.url" alt="Slide" class="carousel_image" />
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
  <div style="width: 100%;">
    <img src="@/images/inimg.png" alt="" style="display: block; margin: 30px auto; max-width: 100%; height: auto;">
  </div>
  <div class="icoBackground">
    <ul class="icoBackground_ul">
      <li class="icoBackground_li" v-for="(item, index) in icoBackground" :key="index">
        <img :style="{ width: mobile ? '100px' : '135px', height: mobile ? '75px' : '100px' }" :src="item.icoBackground_img" alt="">
        <span class="icoBackground_text">{{item.icoBackground_text}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageUrls: [
        { url: require("@/images/u43.png"), link: '/desktopRedcode' },
        { url: require("@/images/u46.png"), link: '/trayCalibrationMachine' },
        { url: require("@/images/u47.png"), link: '/WholePieceReadcode' }
      ],
      icoBackground: [{
        icoBackground_img: require("@/images/inic03.png"),
        icoBackground_text: "提高存储利用率"
      }, {
        icoBackground_img: require("@/images/inic02.png"),
        icoBackground_text: "提升作业效率"
      }, {
        icoBackground_img: require("@/images/inic03.png"),
        icoBackground_text: "节省人力成本"
      }, {
        icoBackground_img: require("@/images/inic04.png"),
        icoBackground_text: "提升供应链管理能力"
      }, {
        icoBackground_img: require("@/images/inic05.png"),
        icoBackground_text: "结果交付"
      }],
      mobile: false,
      carouselHeight: '640px'
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      if (window.innerWidth <= 768) {
        this.mobile = true;
        this.carouselHeight = '40vw';
      } else {
        this.mobile = false;
        this.carouselHeight = '640px';
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  }
};
</script>

<style scoped>
.carousel_image{
   width: 100%;
  height: 100%;
}
.icoBackground_ul {
  display: flex;
  list-style-type: none;
  padding: 0;
}

.icoBackground_li {
  width: 260px;
  height: 193px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 0.5px solid rgba(147, 147, 147, 0.295);
}

.icoBackground_text {
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-left: -8px;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.icoBackground_li:hover {
  background: url(@/images/inicbg.png) no-repeat;

}

.icoBackground {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}


@media (max-width: 768px) {
  .icoBackground_ul {
    flex-direction: column;
    align-items: center;
  }

  .icoBackground_li {
    width: 80%;
    margin: 10px 0;
  }

  .icoBackground_text {
    font-size: 16px;
    margin-left: 0;
    text-align: center;
  }

  .icoBackground {
    margin: 20px 0;
  }

  img.carousel_image {
    object-fit: cover;
  }


  .icoBackground + div img {
    width: 90%;
    margin: 30px auto;
  }

  .icoBackground_li img {
    width: 100px;
    height: 75px;
  }
}
</style>